import { render, staticRenderFns } from "./DetailExternalApproval.vue?vue&type=template&id=08262b21&"
import script from "./DetailExternalApproval.vue?vue&type=script&lang=js&"
export * from "./DetailExternalApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports